<template>
  <div class="gerenciamento-transportadora">
    <g-card class="card-gerenciamento-transportadora" :expansivel="false" :comecaFechado="false">

     <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Comissões </div>

        </div>

        <div class="linha-separacao"></div>


      </template>
      <div class="titulo-conteudo-filtros subtitulo-comissoes"> 
        Comissões mínimas e máximas para o cálculo do markup.
      </div>

      <div class="campos_comissao">

            <div>
                <div class="titulo-conteudo-filtros"> Comissão Mínima (%) </div>
                <PInputNumber placeholder="Mínima" v-model="minima" inputId="locale-user" :minFractionDigits="2">
                </PInputNumber>
            </div>

            <div>
                <div class="titulo-conteudo-filtros"> Comissão Máxima (%)</div>
                <PInputNumber placeholder="Máxima" v-model="maxima" inputId="locale-user" :minFractionDigits="2">
                </PInputNumber>
            </div>
        </div>

        <div class="botoes-comissao">
            <g-button
                class="gravar-button"
                negritoTexto
                tamanhoTexto="14px"
                gap="10px"
                :sombreado="false"
                @click="editarComissao"
                >
                  GRAVAR
                </g-button>
                <g-button
                class="cancelar-button"
                tipo="cinza"
                negritoTexto
                tamanhoTexto="14px"
                gap="10px"
                :sombreado="false"
                @click="cancelarEdicao"
                >
                  CANCELAR
                </g-button>
        </div>
    </g-card>
  </div>
</template>

<script>
import GerenciamentoComissoes from './GerenciamentoComissoes.js' 
export default GerenciamentoComissoes
</script>

<style scoped>
.subtitulo-comissoes{
  margin-bottom: 15px;
}
.gravar-button{
  width: 200px;
  height: 35px;
}

.cancelar-button{
  width: 200px;
  height: 35px;
}

.botoes-comissao {
    display: flex;
    flex-direction: column;
    justify-self: center;
    justify-items: center;
    align-items: center;
    margin-top: 30px;
    gap: 10px;
    justify-content: center
}

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:600px) {
    .campos_comissao{

        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 1fr;
        grid-column-gap: 10px;
        grid-row-gap: 0px;
    }

    .botoes-comissao {
    display: flex;
    flex-direction: row;
    justify-self: center;
    justify-items: center;
    align-items: center;
    margin-top: 50px;
    gap: 10px;
    justify-content: center
}
.gravar-button{
      width: 250px;
      height: 35px;
    }

    .cancelar-button{
      width: 250px;
      height: 35px;
    }


}

@media (min-width:801px) {
  .gravar-button{
      width: 300px;
      height: 35px;
    }

    .cancelar-button{
      width: 300px;
      height: 35px;
    }

}

@media (min-width:1025px) { 

  .campos_comissao{
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 2rem;

  }

}

@media (min-width:1281px) { 
  .campos_comissao{
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 2rem;

  }
}


</style>
